import { Injectable } from '@angular/core';

@Injectable()
export class NgxMdConfig {
  /** config modue */
}
